import styled from 'styled-components';
import { Field } from 'react-final-form';
import CalendarFormPopup from 'components/Form/FinalForm/CalendarFormPopup';
import CalendarIcon from 'components/Icons/calendar_bold.svg';
import { formatYearAndMonth } from 'utils/dates';
import { usePopoverControls } from 'hooks';
import { useUpdateImage } from 'pages/ListerVehicleUploadV2/hooks/useUpdateImage';
import { SectionImage } from 'services/api/vehicle-sections/types';
import { useFieldArray } from 'react-final-form-arrays';

const DisplayWrapper = styled.div<{ isSelected: boolean }>`
  background: #f6f6f6;
  border: 1px solid #99999966;

  display: flex;
  align-items: center;
  height: 32px;
  padding: 0 4px;
  gap: 4px;
  min-width: 92px;
  border-radius: 30px;
`;

const DisplayText = styled.span`
  color: #000000;
  font-size: 12px;
  line-height: 16px;
  min-width: fit-content;
  font-weight: 700;
`;

type Props = {
  sectionId: string;
};

export const LicensePlateDate = ({ sectionId }: Props) => {
  const { anchorEl, openPopover, closePopover } = usePopoverControls();

  const [level1, _0, level2, _1] = sectionId.split('.');

  const imageSectionId = `${level1}.subsections.${level2}`;

  const { fields: tires } = useFieldArray<SectionImage>('exterior.subsections.tires.images', {
    subscription: { value: true }
  });

  const licensePlateI = tires.value?.findIndex(img => img?.type === 'tires.license_plate_registration');
  const updateImage = useUpdateImage(imageSectionId, licensePlateI);

  const saveDate = (newDate: string) => updateImage({ expiration_date: newDate });

  return (
    <Field name={`${imageSectionId}.images.${licensePlateI}.expiration_date`}>
      {props => (
        <>
          <DisplayWrapper onClick={openPopover}>
            <CalendarIcon />
            <DisplayText>{formatYearAndMonth(props.input.value)}</DisplayText>
          </DisplayWrapper>
          <CalendarFormPopup {...props} afterChange={saveDate} close={closePopover} anchorEl={anchorEl} />
        </>
      )}
    </Field>
  );
};
